module.exports = __webpack_public_path__ + "assets/img/title-1af97229.png";